<list-header
  [accountsLimit]="5"
  [cdsShimmer]="componentLoading$ | async"
  [shimmerParams]="{ height: 130, width: '100%', marginTop: 10 }"
/>
